import * as React from 'react';
import { Form } from '@ant-design/compatible';
import { Modal, Popover, Row, Switch } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { BUYER_ADMIN_ONLY, SUPPLIER_ADMIN_ONLY } from '../roles/roles';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getBuyerCompanySettingValue, isBuyerOrInternalTech } from '../../utils/AuthUtils';
import { useMemo } from 'react';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { connect } from 'react-redux';

const WorkOrderIsPrivateFormItem = ({
	form,
	currentUser,
	workOrder,

	isPrivate,
	isPrivateModalVisible,
	isPrivateLoading,

	toggleIsPrivate,
	confirmIsPrivateModal,
	cancelIsPrivateModal,

	userType,
	companyConfig,
}) => {
	const { getFieldDecorator } = form;
	const isAdmin = currentUser.roles.some(
		(role) => SUPPLIER_ADMIN_ONLY.has(role) || BUYER_ADMIN_ONLY.has(role)
	);
	const subscriberEmails = [
		...nullSafeGetOrElse('supplierSubscriberEmails', workOrder, []),
		...nullSafeGetOrElse('buyerSubscriberEmails', workOrder, []),
	];
	const isUserSubscribed = subscriberEmails.includes(currentUser.email);

	const allowWorkOrdersToBeMarkedPrivate = useMemo(
		() =>
			getBuyerCompanySettingValue(userType)(
				'workOrder.allowWorkOrderToBeMarkedPrivate',
				companyConfig,
				currentUser,
				false
			),
		[companyConfig, currentUser, userType]
	);

	return (
		allowWorkOrdersToBeMarkedPrivate && (
			<Form.Item
				label="Is Private Work Order"
				hidden={!(isAdmin && isBuyerOrInternalTech(currentUser))}
			>
				{getFieldDecorator('isPrivate', {
					initialValue: !!isPrivate,
					valuePropName: 'checked',
				})(
					<Row>
						<Switch checked={isPrivate} onChange={toggleIsPrivate} loading={isPrivateLoading} />
						<Modal
							visible={isPrivateModalVisible}
							title={'Warning'}
							okText={'Make this Work Order Public'}
							onOk={confirmIsPrivateModal}
							onCancel={cancelIsPrivateModal}
						>
							<span>
								Turning this off will make the work order visible to all users with access to this
								location.
							</span>
						</Modal>
						<Popover
							content={
								<span>Private work orders can only be seen by the work order subscribers</span>
							}
						>
							<InfoCircleOutlined
								style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}
							/>
						</Popover>
					</Row>
				)}
			</Form.Item>
		)
	);
};

const mapStateToProps = (state, ownProps) => ({
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

const ComponentWithoutUserType = connect(
	mapStateToProps,
	mapDispatchToProps
)(WorkOrderIsPrivateFormItem);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
